import { GET_PROFILES_REQUEST, GET_PROFILES_SUCCESS, GET_PROFILES_FAILURE } from '../actions/profiles';
import { buildProfiles } from '../helpers/profiles';
const initialState = {
    fetching: false,
    profiles: []
};

export default (state = initialState, action) => {

    switch (action.type) {
        case GET_PROFILES_REQUEST: {
            return {
                ...state,
                fetching: true
            };
        }
        case GET_PROFILES_SUCCESS: {
            return {
                ...state,
                fetching: false,
                profiles: buildProfiles(action.payload.profiles)
            };
        }
        case GET_PROFILES_FAILURE: {
            return {
                ...state,
                fetching: false
            };
        }

        default: return state;
    }
};